export interface UserAgency {
  agencyId: string;
  accountCode: string;
  agencyName: string;
}
export interface UseGetUserAgencyResult {
  isLoading: boolean;
  isError: boolean;
  data: UserAgency;
}

export const initializeUserAgencyData = async (id: string, token: string): Promise<UseGetUserAgencyResult> => {
  const headers = new Headers();
  headers.set('Authorization', `Bearer ${token}`);
  const response = await fetch(`/api/agency/agencies/${id}`, { headers: headers });
  const data = await response.json();
  setUserAgencyData(data);
  return data;
};

let userAgencyData: UseGetUserAgencyResult;

export const getUserAgencyData = (): UseGetUserAgencyResult => userAgencyData;

const setUserAgencyData = (data: UseGetUserAgencyResult): void => {
  userAgencyData = data;
};
